import React, { Component, useState, useEffect, Suspense, useRef } from 'react';
import { Route, Switch, useHistory, Redirect } from 'react-router-dom';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import _ from 'lodash';
import ReactNotification from 'react-notifications-component';
import 'react-notifications-component/dist/theme.css';
import { Carousel } from 'react-responsive-carousel';
import { Modal } from 'reactstrap';
import { LazyLoadImage } from 'react-lazy-load-image-component';
import { isAfter, isBefore, isSameDay } from 'date-fns';

// constants
import 'react-responsive-carousel/lib/styles/carousel.min.css';
import routes from '../routes.js';
import Loader from '../components/Common/loader';
import LocalStrings from '../languages';
import {
  FILES_URL,
  APP_API_KEY,
  DEVELOPMENT_TYPE
} from '../components/Common/constant';
import {
  OutsideClickDetector,
  useInterval
} from '../components/Common/util-common.js';

// actions
import {
  fetchEventDetails,
  fetchEventForms,
  fetchTicketStripe,
  checkToken,
  fetchContentTabs,
  fetchMyProfile,
  redirectingCalledFrom,
  fetchAdvertisements,
  fetchWebviewDetails,
  fetchTicketsForEvent,
  fetchTickets,
  postAnalytics,
  setSiteControl
} from '../actions';
import { fetchMyCourses } from '../components/course-overview/actions';
import { fetchMyLiveSessions } from '../components/livesessions/actions';
import { fetchSurvey, selectCurrentSurvey } from '../components/survey/actions';
import {
  setSponsor,
  clearAllSponsor,
  clearSponsorDetails,
  fetchAllSponsor,
  fetchSponsorDetails
} from '../components/sponsors/actions';
import {
  setExhibitor,
  clearAllExhibitor,
  clearExhibitorDetails,
  fetchAllExhibitor,
  fetchExhibitorDetails
} from '../components/exhibitors/actions';

// components & files
import AdminNavbar from '../components/Navbars/AdminNavbar.js';
import Sidebar from '../components/Sidebar/Sidebar';
import FourZeroFour from '../components/Common/pagenotfound';
import SurveyForm from '../components/survey/components/survey-form';
import noimg from '../assets/img/placeholders/NoImg.svg';
import { showError } from '../components/Common/alertmessage/index.js';

const getFaviconEl = () => {
  return document.getElementById('favicon');
};

const Admin = props => {
  const {
    isLoggedIn,
    session,
    deviceSize,
    eventDetails,
    unauthorisedApiCalled,
    show,
    location,
    eventTabs,
    sideAdvtList,
    loadSurvey,
    surveyRecord,
    splashAdsArr,
    incorrectEvent = false,
    siteControl
  } = props;

  const history = useHistory();
  const sidenavRef = useRef(null);
  const sidenavoutsideClicked = OutsideClickDetector(sidenavRef, show);

  const [isMobileCall, setIsMobileCall] = useState(false);
  const [isInvalidURL, setIsInvalidURL] = useState(false);
  const [renderSidebar, setRenderSidebar] = useState(true);
  const [sideAdPostAnalyticsCalled, setSideAdPostAnalyticsCalled] = useState(
    false
  );
  const [cookieState, setCookieState] = useState({ show: false, status: '' }); // status => accept/denied

  var routesNew = routes;
  var matched = false;

  useEffect(() => {
    // ----------- setting dynamic event logo and name index.html head ------------
    let eventlogo =
      'https://uploads-ssl.webflow.com/61cee5eb4d566d3471eca114/6225b2994858c92ff025b7b4_Eventify%20Favicon.png';

    if (!incorrectEvent && eventDetails.resource.eventicon) {
      eventlogo =
        FILES_URL +
        '/' +
        eventDetails.resource.eventicon +
        '?api_key=' +
        APP_API_KEY;

      document.title = eventDetails.resource.eventname;
    } else if (incorrectEvent) {
      document.title = LocalStrings.common_wrong_event_tab_title;
      setIsInvalidURL(true);
    }

    const favicon = getFaviconEl();
    favicon.href = eventlogo;
    // ------------------ dynamic event logo and name setting ends -----------------

    // setRoutesNew(routes);

    // if (DEVELOPMENT_TYPE === 'koachify') {
    //   // props.fetchEventDetails(session);
    //   props.fetchEventForms(session);
    //   props.fetchTicketStripe(session);

    //   if (isLoggedIn == true) {
    //     props.fetchMyCourses(session);
    //     props.fetchMyLiveSessions(session);
    //   }
    // }

    if (location.pathname === '/myprofile' && !_.isEmpty(location.search)) {
      const queryParams = new URLSearchParams(location.search);
      const token = queryParams.get('token');
      const appuserid = queryParams.get('appuserid');
      const eventid = queryParams.get('eventid');

      setIsMobileCall(true);
      setRenderSidebar(false);

      if (token && appuserid && eventid) {
        props.checkToken(token, appuserid, eventid, response => {
          if (response.success == 0) {
            setIsInvalidURL(true);
          }
        });
      } else {
        setIsInvalidURL(true);
      }
    }

    if (location?.search == '') {
      if (DEVELOPMENT_TYPE === 'koachify') {
        // props.fetchEventForms(session);
        props.fetchTicketStripe(session);

        if (isLoggedIn == true) {
          props.fetchMyCourses(session);
          props.fetchMyLiveSessions(session);
        }
      }

      if (isLoggedIn && !_.isEmpty(session?.sessionToken)) {
        props.fetchMyProfile(session, res => {});
        props.fetchTickets(session, res => {});
      }
    }

    // --- Moved this as per client expiry logic
    // props.fetchContentTabs(session, res => {});
    // if (location.pathname.includes('/mapdetails')) {
    //   history.push('/maps');
    // } else if (location.pathname.includes('/newsdetails')) {
    //   history.push('/news');
    // }
  }, [location, incorrectEvent, eventDetails]);

  useEffect(() => {
    // --- Error message to show on aunauthorozied API call
    if (unauthorisedApiCalled) showError(LocalStrings.common_error_unauth_call);

    if (!_.isEmpty(eventDetails.resource)) {
      let accessType = 'allow';

      if (!_.isEmpty(eventDetails.resource.clients_by_clientidfk)) {
        // --- Clients validity dates
        let client_validity_from = new Date(
          `${eventDetails.resource.clients_by_clientidfk?.validityfrom} 00:00:00`
        );
        let client_validity_upto = new Date(
          `${eventDetails.resource.clients_by_clientidfk?.validupto} 00:00:00`
        );

        // --- Determining the access type
        if (isAfter(new Date(), client_validity_upto)) accessType = 'expired';
        else if (isBefore(new Date(), client_validity_from))
          accessType = 'restrict';
        else accessType = 'allow';
        if (
          isSameDay(new Date(), client_validity_from) ||
          isSameDay(new Date(), client_validity_upto)
        )
          accessType = 'allow';
      }

      props.setSiteControl(accessType);

      // ----- Can not access site
      if (accessType === 'expired') {
        // setRenderSidebar(false);

        // --- Redirecting to 404 page
        history.push('/fourzerofour');
      } else {
        // --- Common API calls
        props.fetchContentTabs(session, res => {});

        if (accessType === 'restrict') {
          // --- Hold on overview with login modal and display client validation message toast

          // But if lets login, redirecting to myprofile
          if (isLoggedIn) history.push('/myprofile');
        } else {
          // ----- Allow full site access
          if (isLoggedIn && !_.isEmpty(session?.sessionToken)) {
            props.fetchEventForms(session, res => {});
            props.fetchAdvertisements(session, res => {});
            props.fetchWebviewDetails(session, res => {});
            if (!_.isEmpty(session.sessionToken))
              props.fetchTicketsForEvent(session, res => {});

            if (!isMobileCall && loadSurvey)
              props.fetchSurvey(session, res => {});

            if (location.pathname.includes('/mapdetails')) {
              history.push('/maps');
            } else if (location.pathname.includes('/newsdetails')) {
              history.push('/news');
            }
          }
        }
      }
    }

    // if (location.pathname === '/myprofile') {
    //   if (location.search && location.search != '') {
    //     setRenderSidebar(false);
    //   }
    // } else if (!isMobileCall && loadSurvey && isLoggedIn) {
    //   props.fetchSurvey(session, res => {});
    //   props.fetchAdvertisements(session, res => {});
    //   props.fetchWebviewDetails(session, res => {});
    //   props.fetchTicketsForEvent(session, res => {});
    // }

    // if (isLoggedIn) props.fetchEventForms(session, res => {});
  }, [loadSurvey, isLoggedIn, isMobileCall]);

  useEffect(() => {
    if (siteControl === 'restrict' && session.isadmin) {
      history.push('/overview');
      props.setSiteControl('allow-admin');
    }
  }, [siteControl, session]);

  const handleSidemenuAdAnalytics = () => {
    let promiseArr = [];
    _.map(sideAdvtList, thisAd => {
      promiseArr.push(
        new Promise((resolve, reject) => {
          props.postAnalytics(
            session,
            'sidemenu',
            'ad_view',
            thisAd.advtid,
            null,
            0,
            res => {
              resolve();
            }
          );
        })
      );
    });

    Promise.all(promiseArr);
  };

  if (!_.isEmpty(sideAdvtList) && isLoggedIn && !sideAdPostAnalyticsCalled) {
    handleSidemenuAdAnalytics();
    setSideAdPostAnalyticsCalled(true);
  }

  if (eventTabs?.length > 0) {
    _.map(routesNew, (val, index) => {
      var match = _.filter(eventTabs, o => {
        return o.tabslected == val.key;
      });

      var obj = val;
      if (match && match.length > 0) {
        obj.name = match[0].displaytabname;
        obj.display = match[0].isenabled;
        obj.taborder = match[0].taborder;
      } else {
        obj.name = LocalStrings[val.languageKey];
        obj.display = val.display;
        obj.taborder = '-1';
      }
    });

    var sortArrAvailable = _.sortBy(routesNew, 'taborder', 'asc');
    routesNew = sortArrAvailable;
  }

  const getRoutes = routesNew => {
    // return routesNew.map((prop, key) => {
    //   return <Route path={prop.path} component={prop.component} key={key} />;
    // });

    // -------------------------------------- New Changes --------------------------------------
    if (isLoggedIn) {
      return routesNew.map((prop, key) => {
        if (session?.eventid == 1780731138296391) {
          if (prop.path !== '/agenda')
            return (
              <Route
                key={`key_${key}`}
                path={prop.path}
                component={prop.component}
                // key={key}
              />
            );
        } else
          return (
            <Route
              key={`key_${key}`}
              path={prop.path}
              component={prop.component}
              // key={key}
            />
          );
      });
    } else {
      return routesNew.map((prop, key) => {
        if (
          prop.path == '/autologin' ||
          prop.path == '/overview' ||
          prop.path == '/featured-courses' ||
          prop.path == '/related-courses' ||
          prop.path == '/popular-courses' ||
          prop.path == '/all-courses' ||
          prop.path == '/liveclass-details' ||
          prop.path == '/course-details' ||
          prop.path == '/mycoursedetails'
        ) {
          return (
            <Route
              key={`key_${key}`}
              path={prop.path}
              component={prop.component}
              // key={key}
            />
          );
        } else if (isMobileCall && prop.path == '/myprofile') {
          return (
            <Route
              key={`key_${key}`}
              path={prop.path}
              component={prop.component}
              // key={key}
            />
          );
        } else {
          return (
            <Route
              key={`key_${key}`}
              path={prop.path}
              render={() => <Redirect to="/overview" />}
              // key={key}
            />
          );
        }
      });
    }
  };

  const getBrandText = path => {
    let routes = routesNew;

    for (let i = 0; i < routes.length; i++) {
      if (props.location.pathname.indexOf(routes[i].path) !== -1) {
        return routes[i].name;
      }
    }
  };

  const handleAdSelected = adItem => {
    var selectedAd = sideAdvtList[adItem];

    props.postAnalytics(
      session,
      'sidemenu',
      'ad_click',
      selectedAd.advtid,
      null,
      0,
      res => {}
    );

    switch (selectedAd?.internalscreen) {
      case 'exhibitor':
        props.redirectingCalledFrom('admin-ad');
        // --- clear
        props.setExhibitor({});
        props.clearAllExhibitor();
        props.clearExhibitorDetails();
        // --- redirection
        history.push('/exhibitors');
        // --- fetch
        props.fetchAllExhibitor(
          session,
          { type: 'redirection', id: selectedAd.relatedid },
          res => {}
        );
        break;

      case 'sponsor':
        props.redirectingCalledFrom('admin-ad');
        // --- clear
        props.setSponsor({});
        props.clearAllSponsor();
        props.clearSponsorDetails();
        // --- redirection
        history.push('/sponsors');
        // --- fetch
        props.fetchAllSponsor(
          session,
          {
            type: 'redirection',
            id: selectedAd.relatedid
          },
          res => {}
        );
        break;

      default:
        break;
    }
  };

  return (
    <>
      {isInvalidURL ? (
        <>
          {/* <div className="item-center">{LocalStrings.invalid_url}</div> */}
          <FourZeroFour />
        </>
      ) : (
        <>
          {eventTabs?.length > 0 ? (
            <div className="row full-height">
              {/* --------------- sidebar section start -------------- */}

              {/* ---------- controlling sidebar for mobile call and not loading ------- */}
              {renderSidebar ? (
                <>
                  {/* ------------ tab & upwards ------------ */}
                  {isLoggedIn == true ? (
                    <div
                      className={`d-none d-sm-none d-md-none d-lg-block col-lg-1 col-xl-2 ${
                        siteControl !== 'restrict' ? 'sidebar-container ' : ''
                      }background-white ${
                        _.isEmpty(sideAdvtList) && siteControl !== 'restrict'
                          ? 'sidenav-regular  scrollbar-hide-no-maxheight'
                          : ''
                      }`}
                    >
                      <div
                        className={
                          !_.isEmpty(sideAdvtList)
                            ? ` scrollbar-hide-no-maxheight`
                            : ''
                        }
                        style={
                          !_.isEmpty(sideAdvtList) && deviceSize != 1024
                            ? {
                                height: deviceSize.height - 78
                              }
                            : { height: '100%' }
                        }
                      >
                        <Sidebar
                          {...props}
                          routes={routesNew}
                          logo={{
                            innerLink: '/admin/index',
                            imgSrc: require('../assets/img/brand/dreamvolt_logo.png'),
                            imgAlt: '...'
                          }}
                        />
                      </div>

                      {/* bottom ad */}
                      {!_.isEmpty(sideAdvtList) &&
                      siteControl !== 'restrict' ? (
                        <div className="" style={{ marginRight: 15 }}>
                          <div
                            className="pt-2 pb-2"
                            id="advertisement"
                            style={{
                              borderRadius: 10,
                              marginBottom: 4
                            }}
                          >
                            <Carousel
                              autoPlay={true}
                              // centerMode={true}
                              // emulateTouch={true}
                              infiniteLoop={true}
                              interval={10000}
                              // useKeyboardArrows={false}
                              // width={60}
                              showThumbs={false}
                              showArrows={false}
                              showStatus={false}
                              stopOnHover={false}
                              showIndicators={
                                sideAdvtList.length > 1 ? true : false
                              }
                              onClickItem={item => handleAdSelected(item)}
                              onClickThumb={item => handleAdSelected(item)}
                            >
                              {_.map(sideAdvtList, (ad, key) => {
                                if (ad.externallink) {
                                  return (
                                    <div key={`add_${key}`}>
                                      <div
                                        className=""
                                        style={{
                                          borderRadius: 10
                                        }}
                                      >
                                        <a
                                          href={ad.externallink}
                                          target="_blank"
                                          style={{
                                            borderRadius: 10
                                          }}
                                        >
                                          <div className="">
                                            <LazyLoadImage
                                              effect="blur"
                                              placeholder={
                                                <img
                                                  src={noimg}
                                                  alt="lazy load placeholder on error"
                                                />
                                              }
                                              src={`${FILES_URL}/${ad.bannerimg}?api_key=${session.apiKey}`}
                                              alt={'ad goes here'}
                                              style={{
                                                borderRadius: 10
                                              }}
                                              onError={e => {
                                                e.target.onerror = null;
                                                e.target.src = noimg;
                                              }}
                                            />
                                          </div>
                                        </a>
                                      </div>
                                    </div>
                                  );
                                } else {
                                  return (
                                    <div key={`add_${key}`}>
                                      <div
                                        className=""
                                        // onClick={() => {}}
                                        style={{
                                          borderRadius: 10
                                        }}
                                      >
                                        <LazyLoadImage
                                          effect="blur"
                                          placeholder={
                                            <img
                                              src={noimg}
                                              alt="lazy load placeholder on error"
                                            />
                                          }
                                          src={`${FILES_URL}/${ad.bannerimg}?api_key=${session.apiKey}`}
                                          alt="ad goes here"
                                          style={{
                                            borderRadius: 10
                                          }}
                                          onError={e => {
                                            e.target.onerror = null;
                                            e.target.src = noimg;
                                          }}
                                        />
                                      </div>
                                    </div>
                                  );
                                }
                              })}
                            </Carousel>
                          </div>
                        </div>
                      ) : (
                        ''
                      )}
                    </div>
                  ) : (
                    ''
                  )}

                  {/* ---------- mobile --------- */}
                  {isLoggedIn == true ? (
                    <div
                      ref={sidenavRef}
                      className={`d-lg-none sidenav ${
                        show ? 'sidenav-boxshadow' : ''
                      }`}
                      style={{
                        transform:
                          show == true ? 'translateX(0)' : 'translateX(-100%)'
                      }}
                    >
                      <Sidebar
                        ref={sidenavRef}
                        sidenavoutsideClicked={sidenavoutsideClicked}
                        {...props}
                        routes={routesNew}
                        isMobile
                        logo={{
                          innerLink: '/admin/index',
                          imgSrc: require('../assets/img/brand/dreamvolt_logo.png'),
                          imgAlt: '...'
                        }}
                        componentHeight={
                          !_.isEmpty(sideAdvtList) && deviceSize.height != 1024
                        }
                      />

                      {/* bottom ad */}
                      {!_.isEmpty(sideAdvtList) &&
                      siteControl !== 'restrict' ? (
                        <div
                          className="sidebar-container"
                          style={{
                            paddingRight: 2,
                            paddingLeft: 2
                          }}
                        >
                          <div
                            className="pt-2 pb-2"
                            id="advertisement"
                            style={{
                              borderRadius: 10
                            }}
                          >
                            <Carousel
                              autoPlay={true}
                              // centerMode={true}
                              // emulateTouch={true}
                              infiniteLoop={true}
                              interval={8000}
                              // useKeyboardArrows={false}
                              // width={60}
                              showThumbs={false}
                              showArrows={false}
                              showStatus={false}
                              stopOnHover={false}
                              showIndicators={
                                sideAdvtList.length > 1 ? true : false
                              }
                              onClickItem={item => handleAdSelected(item)}
                              onClickThumb={item => handleAdSelected(item)}
                            >
                              {_.map(sideAdvtList, (ad, key) => {
                                if (ad.externallink) {
                                  return (
                                    <div key={`add_${key}`}>
                                      <div
                                        className=""
                                        style={{
                                          borderRadius: 10
                                        }}
                                      >
                                        <a
                                          href={ad.externallink}
                                          target="_blank"
                                          style={{
                                            borderRadius: 10
                                          }}
                                        >
                                          <div className="">
                                            <LazyLoadImage
                                              effect="blur"
                                              placeholder={
                                                <img
                                                  src={noimg}
                                                  style={{
                                                    height: 125,
                                                    borderRadius: 10
                                                  }}
                                                  alt="lazy load placeholder on error"
                                                />
                                              }
                                              src={`${FILES_URL}/${ad.bannerimg}?api_key=${session.apiKey}`}
                                              alt="ad goes here"
                                              style={{
                                                height: 125,
                                                borderRadius: 10
                                              }}
                                              onError={e => {
                                                e.target.onerror = null;
                                                e.target.src = noimg;
                                              }}
                                            />
                                          </div>
                                        </a>
                                      </div>
                                    </div>
                                  );
                                } else {
                                  return (
                                    <div key={`add_${key}`}>
                                      <div
                                        className=""
                                        // onClick={() => {}}
                                        style={{
                                          borderRadius: 10
                                        }}
                                      >
                                        <LazyLoadImage
                                          effect="blur"
                                          placeholder={
                                            <img
                                              src={noimg}
                                              alt="lazy load placeholder on error"
                                            />
                                          }
                                          src={`${FILES_URL}/${ad.bannerimg}?api_key=${session.apiKey}`}
                                          alt="ad goes here"
                                          style={{
                                            borderRadius: 10
                                          }}
                                          onError={e => {
                                            e.target.onerror = null;
                                            e.target.src = noimg;
                                          }}
                                        />
                                      </div>
                                    </div>
                                  );
                                }
                              })}
                            </Carousel>
                          </div>
                        </div>
                      ) : (
                        ''
                      )}
                    </div>
                  ) : (
                    ''
                  )}
                </>
              ) : (
                ''
              )}

              {/* ---------------- sidebar section end ---------------- */}

              {/* --------------------- main page --------------------- */}
              <div
                className={`col-12 col-sm-12 col-md-12 p-0 ${
                  isLoggedIn == true
                    ? 'col-lg-11 col-xl-10'
                    : 'col-lg-12 col-xl-12'
                }`}
              >
                {/* ------------ top nav bar ------------ */}
                {!isMobileCall ? (
                  <AdminNavbar
                    {...props}
                    routes={routesNew}
                    brandText={getBrandText(props.location.pathname)}
                    pathname={props.location.pathname}
                  />
                ) : (
                  ''
                )}

                {/* -------- main body -------- */}
                <div className="main-content full-height">
                  <Suspense
                    fallback={
                      <>
                        <Loader />
                      </>
                    }
                  >
                    <Switch>
                      {getRoutes(routesNew)}

                      {/* gibrish url 404 redirect */}
                      {!matched &&
                        _.map(routesNew, (r, key) => {
                          if (r.path === location.pathname) {
                            matched = true;
                          } else {
                            return <FourZeroFour key={`key_${key}`} />;
                          }
                        })}

                      {/* if this Route made open then all routes are going /overview */}
                    </Switch>
                  </Suspense>
                </div>
              </div>

              <ReactNotification />

              {/* ---------------- popup sections start ---------------- */}
              {/* ----- Survey popup ----- */}
              {surveyRecord?.mandatory && !_.isEmpty(surveyRecord.mandatory) ? (
                <Modal
                  className="preview-lesson"
                  isOpen={!_.isEmpty(surveyRecord.mandatory)}
                  size="md"
                  centered
                  backdrop={'static'}
                  keyboard={false}
                >
                  <div className="modal-header">
                    <div className="modal-title custom-text2-medium-primary">
                      {LocalStrings.survey_modal_mandatory}:{' '}
                      {surveyRecord.mandatory?.formname}
                    </div>
                  </div>

                  <div className="modal-body">
                    <div
                      className=" scrollbar-hide-no-maxheight full-height border-right"
                      style={{
                        height: deviceSize.height - 240
                      }}
                    >
                      <div>
                        <SurveyForm surveyModal={true} />
                      </div>
                    </div>
                  </div>
                </Modal>
              ) : (
                ''
              )}
              {/* ----------------- popup sections end ----------------- */}
            </div>
          ) : location?.pathname == '/' ? (
            <Redirect from="/" to="/overview" />
          ) : siteControl === 'expired' ? (
            <>
              <div
                className=""
                style={{
                  display: 'flex',
                  flexDirection: 'column',
                  justifyContent: 'center',
                  alignItems: 'center',
                  width: '100%',
                  height: '100vh',
                  gap: 16
                }}
              >
                <span className="custom-text2-medium-primary">
                  {LocalStrings.kValidityExpireTitle}
                </span>
                <span className="custom-text1-normal-secondary">
                  {LocalStrings.kValidityExpireMessage}
                </span>
              </div>
            </>
          ) : (
            <>
              <Loader />
            </>
          )}
        </>
      )}
    </>
  );
};

const mapStateToProps = state => {
  var sideAdvtList = [];
  var splashAds = [];
  var splashAdsArr = [];
  var splashad = {};

  if (state.advtDetails.length > 0) {
    sideAdvtList = _.filter(state.advtDetails, advt => {
      return advt.screen == 'sidemenu';
    });
  }

  var loadSurvey = false;
  if (state.session.userid && state.session.userid !== '') {
    loadSurvey = true;
  }

  if (state.advtDetails.length > 0) {
    splashAds = _.filter(state.advtDetails, advt => {
      return advt.screen == 'splash';
    });
    if (splashAds.length > 0) {
      _.map(splashAds, ad => {
        let splashadobj = {
          ad: ad,
          seen: false
        };
        splashAdsArr.push(splashadobj);
      });
    }
    splashad =
      splashAdsArr[
        splashAdsArr.length == 1 ? 0 : _.random(splashAdsArr.length - 1)
      ];
  }

  return {
    isLoggedIn: state.isLoggedIn,
    session: state.session,
    show: state.showSidebar,
    eventTabs: state.eventTabs,
    deviceSize: state.deviceSize,
    surveyRecord: state.surveyRecord,
    eventDetails: state.eventDetails,
    unauthorisedApiCalled: state.unauthorisedApiCalled,
    siteControl: state.siteControlReducer,
    sideAdvtList,
    loadSurvey,
    splashAdsArr
  };
};

const mapDispatchToProps = dispatch =>
  bindActionCreators(
    {
      fetchEventDetails,
      fetchEventForms,
      fetchMyCourses,
      fetchMyLiveSessions,
      fetchTicketStripe,
      checkToken,
      fetchContentTabs,
      fetchMyProfile,
      fetchSurvey,
      selectCurrentSurvey,
      setSponsor,
      clearAllSponsor,
      clearSponsorDetails,
      fetchAllSponsor,
      fetchSponsorDetails,
      redirectingCalledFrom,
      setExhibitor,
      clearAllExhibitor,
      clearExhibitorDetails,
      fetchAllExhibitor,
      fetchExhibitorDetails,
      fetchAdvertisements,
      fetchWebviewDetails,
      fetchTicketsForEvent,
      fetchTickets,
      postAnalytics,
      setSiteControl
    },
    dispatch
  );

export default connect(mapStateToProps, mapDispatchToProps)(Admin);
